export function getScrollHeightString(itemsCount: number, breakpoint = 16): string {
  if (!itemsCount) {
    return 'auto';
  }

  return itemsCount >= breakpoint ? '340px' : 'auto';
}
